import React from "react";
import VenueOccupancyBar from "./VenueOccupancyBar";
import { useParams } from "react-router-dom";

// Components
import OnlineBookingComponent from "../Common/OnlineBookingTag";
import ClosedVenueComponent from "../Common/ClosedVenueTag";

interface RouteParams {
  channelid: string;
}

const VenueListItem: React.FC<any> = (props: any) => {
  let occupancyPercent: number = Math.trunc(
    (props.venue.currentActivitySession?.occupancy * 100) /
      props.venue.currentActivitySession?.capacity
  );
  let params = useParams<RouteParams>();

  return (
    <div className="list-group mt-3">
      <a
        href={"/" + params.channelid + "/" + props.venue?.oid}
        target="_top"
        className="list-group-item list-group-item-action mb-2"
      >
        <div className="row">
            <div className="col-3 py-0 pl-2 pr-0">
              <img
                src={props.venue?.imageUrl}
                alt={props.venue?.name}
                className="mr-3 img-fluid rounded mx-auto d-block border"
              />
            </div>
            <div className="col-9">
              <div className="row">
                <span className="col-12 mb-0 small lh-125 mb-2">
                  <strong className="d-block small-title">{props.venue?.name}</strong>
                  {props.venue.currentActivitySession && 
                    props.venue.currentActivitySession.isOpen && 
                      props.venue.currentActivitySession.activityName.length !== "" && 
                        (
                          <h6 className="blue2 mb-3">
                            {props.venue.currentActivitySession.activityName}
                          </h6>
                        )
                  }

                {props.venue.currentActivitySession && 
                  props.venue.currentActivitySession.isOpen && 
                    (
                      <React.Fragment>
                            <span className="gray">
                              {" "}
                              <b className="black">{occupancyPercent}%</b> d'ocupació
                              ({" "}
                              <b className="black">
                                {props.venue.currentActivitySession.occupancy}
                              </b>{" "}
                              / {props.venue.currentActivitySession.capacity})
                            </span>
                            <div className="progress">
                              <VenueOccupancyBar venue={props.venue} />
                            </div>
                      </React.Fragment>
                    )
                  }
                </span>

                {props.venue.isPublished && (
                  <OnlineBookingComponent {...props}/>
                )}

                {!props.venue.isPublished && (props.venue.currentActivitySession == null || !props.venue.currentActivitySession.isOpen) &&
                  <ClosedVenueComponent/>
                }
              </div>
            </div>
        </div>
      </a>
    </div>
  );
};

export default VenueListItem;
